export const colorsJson = [
  {
    variant: 'primary',
    tone: '100'
  },
  {
    variant: 'support-02',
    tone: '800'
  },
  {
    variant: 'secondary-02',
    tone: '300'
  },

  {
    variant: 'support-05',
    tone: '500'
  },
  {
    variant: 'support-04',
    tone: '300'
  },
  {
    variant: 'support',
    tone: '800'
  }
];
